<template>
  <v-card>
    <v-card-title>Site Setup Date & Time</v-card-title>
    <v-card-text>
      <span v-if="assignment_data.performance_site.setup_date">
        {{ assignment_data.performance_site.setup_date | formatDate }} @ {{ assignment_data.performance_site.setup_time | formatTime }}
      </span>
      <span v-else class="font-italic">This has not yet been set by the DC staff.</span>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    assignment_data: Object
  },
  filters: {
    formatDate: function(date) {
      return moment.utc(date).format('MM/DD/YYYY')
    },
    formatTime: function(time) {
      return moment.utc(time).format('h:mm a')
    }
  }
}
</script>